import { useTranslations } from "next-intl";

/** "lub" separator between the credentials form and the social buttons. */
export const AuthDivider = ({ label }: { label?: string }) => {
  const t = useTranslations("auth");

  return (
    <div className="flex items-center gap-3">
      <span aria-hidden="true" className="h-px flex-1 bg-border" />
      <span className="text-sm text-text-subtle leading-[22px]">
        {label ?? t("social.divider")}
      </span>
      <span aria-hidden="true" className="h-px flex-1 bg-border" />
    </div>
  );
};
